import { render, staticRenderFns } from "./associationActivityList.vue?vue&type=template&id=badd789a"
import script from "./associationActivityList.vue?vue&type=script&lang=js"
export * from "./associationActivityList.vue?vue&type=script&lang=js"
import style0 from "./associationActivityList.vue?vue&type=style&index=0&id=badd789a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports